import ContestTaskLeaderboardMap from "../views/ContestTaskLeaderboardMap";
import AllLeaderboardTracks from "../views/AllLeaderboardTracks";
import LeaderboardBestScores from "../views/LeaderboardBestScores";

export default class ContestTaskLeaderboard {

    constructor() {
        this.leaderboardMap = new ContestTaskLeaderboardMap();
        this.allTracks = new AllLeaderboardTracks();
        this.bestScores = new LeaderboardBestScores();
        window.application.setOnDataChangeListener(this);

        this.bindEvents();
    }


    bindEvents() {
        $("a[href*='#']:not([href='#'])").unbind("click").click(function(e) {
            // Only handle same-page anchor links
            if (
                location.hostname == this.hostname
                && this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//,"")
            ) {
                e.preventDefault();
                var anchor = $(this.hash);
                anchor = anchor.length ? anchor : $("[name=" + this.hash.slice(1) +"]");
                if ( anchor.length ) {
                    $("html, body").animate( { scrollTop: anchor.offset().top-70 }, 500);
                }
            }
            // For cross-page anchor links, let the browser handle navigation normally
        });
    }

    onDataChanged(data) {
        this.leaderboardMap.onDataChanged(data);
        this.allTracks.onDataChanged(data);
        this.bestScores.onDataChanged(data);
    }

    onDestroy(){
        $("a[href*='#']:not([href='#'])").unbind("click");
        this.leaderboardMap.onDestroy();
        this.allTracks.onDestroy();
        this.bestScores.onDestroy();
    }
}
